import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { Notify } from "notiflix";
import { RoutingService } from '../services/routing.service';

@Injectable()
export class HttpResponseInterceptor implements HttpInterceptor {

  constructor(
    private _rs: RoutingService,
    private _auths: AuthService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status == 401) {
            // this._auths.logout();
          } else if (err.status == 400) {
            if (err.error && err.error.error) {
              Notify.failure(err.error.error);
            } else {
              Notify.failure("Server error (X400)!");
            }
          } else if (err.status == 422) {
            if (err.error && err.error.error) {
              Notify.failure(err.error.error);
            } else if (err.error) {
              Notify.failure(err.error);
            } else {
              Notify.failure("Server error (X422)!");
            }
          } else if (err.status == 500) {
            Notify.failure("Server error (X500)!");
          } else {
            // TODO
            Notify.failure("Error occurred!");
          }
        }
        throw err;
      }));
  }
}
